import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Cushion, Panel } from '@pitchero/react-ui';
import { isLoggedIn } from '../../../store/auth/selectors';
import LoginForm from '../../auth/login-form';

const JoinClubPanel = ({ isOpen, loggedIn, onClose, addToBasket, joinParams }) => {
  useEffect(() => {
    if (isOpen && loggedIn) {
      addToBasket();
    }
  }, [isOpen, loggedIn]);

  return (
    <Panel isOpen={isOpen} onClose={onClose}>
      <Cushion horizontal="large">
        <LoginForm
          titleI18nKey="shop:login_form_title"
          titlePreset="subtitle--large"
          joinParams={joinParams}
        />
      </Cushion>
    </Panel>
  );
};

const mapStateToProps = (state) => ({
  loggedIn: isLoggedIn(state),
});

JoinClubPanel.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  loggedIn: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  addToBasket: PropTypes.func.isRequired,
  joinParams: PropTypes.shape().isRequired,
};

export default connect(mapStateToProps)(JoinClubPanel);
